import { createElement, memo, useCallback, useEffect, useRef, useState } from '@max/max';
import View from '@hfe/max-view';
import CurrentPosition from './CurrentPosition/CurrentPosition';
import './CitySelection.scss';
import SearchArea from './SearchArea/SearchArea';
import LetterIndex from './LetterIndex/LetterIndex';
import CityList from './CityList/CityList';
import ScrollView from '@hfe/max-scrollview';
import { getLetters } from './cityUtil';
const isMRN = false;
const isWeb = true;
import { screenHeight, reverseRem, statusBarHeight, isAndroid } from '../until';
function CitySelection(props) {
    const scrollViewRef = useRef(null);
    const [isSuggestArea, setIsSuggestArea] = useState(false);
    const [currentLetter, setCurrentLetter] = useState('');
    const [positions, setPositions] = useState();
    const reachEnd = useCallback(() => { }, []);
    const scrollTo = (pos) => {
        scrollViewRef && scrollViewRef.current && scrollViewRef.current.scrollTo({
            y: isWeb ? pos - 127 : pos - 380,
            animated: true,
            duration: 100
        });
    };
    const receiveLetter = useCallback((letter) => {
        // console.log('current letter', letter);
        setCurrentLetter(letter);
    }, []);
    const receivePositions = useCallback((pp) => {
        setPositions(pp);
    }, []);
    useEffect(() => {
        if (currentLetter && currentLetter.length > 0) {
            const index = getLetters(props === null || props === void 0 ? void 0 : props.cityData).indexOf(currentLetter);
            (positions === null || positions === void 0 ? void 0 : positions[index]) && scrollTo(positions[index]);
        }
    }, [currentLetter, positions]);
    const emitCloseEventCallback = useCallback(() => {
        //props.dispatchEvent && props.dispatchEvent({ type: Actions.toggleCitySelection });
    }, []);
    const emitSearchValueChangeCallback = useCallback((value) => {
        if (value !== '') {
            console.log('emitSearchValueChangeCallback');
            setIsSuggestArea(true);
        }
        else {
            setIsSuggestArea(false);
        }
    }, []);
    return <View style={{
        height: isWeb ? isAndroid ? '100vh' : `${screenHeight - statusBarHeight}px` : reverseRem(screenHeight - statusBarHeight)
    }}>
      <SearchArea cityData={props === null || props === void 0 ? void 0 : props.cityData} onClose={props === null || props === void 0 ? void 0 : props.onClose} emitCloseEvent={emitCloseEventCallback} emitSearchValueChange={emitSearchValueChangeCallback} allStates={props.allStates} dispatchEvent={props.dispatchEvent} emitCity={props === null || props === void 0 ? void 0 : props.emitCity}/>
      <View x-if={!isSuggestArea}>
        <ScrollView showsVerticalScrollIndicator={false} refreshType={'system'} ref={scrollViewRef} className={'city-selection-scroll-view-main'} style={{
        height: isMRN ? '100%' : '100vh'
    }} disableScroll={false} onEndReached={reachEnd} onEndReachedThreshold={100}>
          <CurrentPosition emitCity={props === null || props === void 0 ? void 0 : props.emitCity} dispatchEvent={props.dispatchEvent} locationCity={props.city}/>
          <CityList cityData={props === null || props === void 0 ? void 0 : props.cityData} emitCity={props === null || props === void 0 ? void 0 : props.emitCity} currentLetter={currentLetter} emitPositions={receivePositions}/>
          <View x-if={!isAndroid} className="city-selection-margin"/>
        </ScrollView>
        <LetterIndex cityData={props === null || props === void 0 ? void 0 : props.cityData} emitCurrentLetter={receiveLetter}/>
      </View>
    </View>;
}
export default memo(CitySelection);
